import { of, forkJoin } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { getJSON } from './fetchUtils'

export const fetchMultiplePatientData = ({
  validIds,
  apiEndpoint,
  dataType,
  resultStructure,
}) => {
  return forkJoin(
    validIds.map(id =>
      getJSON(`${apiEndpoint}${id}/`).pipe(
        catchError(error => {
          console.error(`Failed to fetch ${dataType} for patient ${id}:`, error)
          return of(resultStructure)
        })
      )
    )
  )
}
